import { combineReducers } from 'redux';

import cultures from './cultures';

export default combineReducers({
    cultures
});
